import EInfoModal from '@/components/everridge/EInfoModal';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
	onSubmit: () => void;
	onClose: () => void;
};

const NewAndOfferArchiveModal: FC<Props> = ({ onSubmit, onClose }) => {
	const { t } = useTranslation();

	return (
		<EInfoModal
			label={t('main.newsAndOffers.components.archiveModal.label')}
			description={t('main.newsAndOffers.components.archiveModal.description')}
			submitName='Archive'
			submitVariant='alert'
			onSubmit={onSubmit}
			onClose={onClose}
		/>
	);
};

export default NewAndOfferArchiveModal;
